import React from 'react'
import { PlanDetailType } from 'service/plans'

export const FeatureBox = ({
  planDetail,
  planId,
  index,
}: {
  planDetail: PlanDetailType
  planId: number
  index: number
}) => {
  return (
    <>
      {planDetail.type === 'feature' && (
        <p
          className="font-bold text-[18px] flex items-center gap-[5px] mb-[24px]"
          key={index}
        >
          <img
            src={
              planId === 5
                ? 'assets/img/check_circle_blue.png'
                : 'assets/img/check_circle.png'
            }
            alt="check_circle"
            width={24}
            height={24}
          />
          <span className="relative">
            <span
              className={`relative inline-block ${
                planDetail.highlight
                  ? 'after:absolute after:left-0 after:bottom-[2px] after:w-full after:h-[10px] after:bg-[#FD6767] after:opacity-40 after:-z-10'
                  : ''
              }`}
            >
              {planDetail.name}
            </span>
          </span>
          {planDetail.cash && (
            <span className="flex items-center gap-1 text-[12px]">
              <img
                src="assets/img/cash.png"
                alt="check_circle"
                width={11.9}
                height={14}
              />
              <span className="text-main text-[12px]">캐시 필요</span>
              <button
                className="text-white bg-main py-1 px-2 rounded-[4px] "
                //   onClick={handleCashPaymentModal}
              >
                충전하기
              </button>
            </span>
          )}
        </p>
      )}
    </>
  )
}
